import { Container, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { InsightItemComponent } from '../components/Insights/InsightItem';
import { InsightArchiveTable } from '../components/Table/InsightArchiveTable';
import type { RootState } from '../../store';
import { ActionItemComponent } from '../components/Insights';
import { useGlobalLoading } from '../../context';

const InsightDetails = () => {
  const { isLoading } = useSelector((state: RootState) => state.insights);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const { stopLoading } = useGlobalLoading();

  // Check if actions feature is enabled
  const areActionsEnabled =
    selectedTenancy?.features?.actions?.enabled !== false;

  if (!isLoading) {
    stopLoading();
    return (
      <>
        <Container fluid>
          <h1 className="heading1" style={{ marginTop: '23px' }}>
            {areActionsEnabled ? 'All insights and actions' : 'Insights'}
          </h1>
          {areActionsEnabled && <ActionItemComponent />}
          <InsightItemComponent />
        </Container>

        <div style={{ marginTop: '10px', marginRight: '75px' }}>
          <InsightArchiveTable />
        </div>
      </>
    );
  } else {
    return (
      <>
        <Container fluid>
          <div className="mySpinner">
            <div>
              <Spinner animation="border" role="status"></Spinner>
              <span>
                <br />
                Loading...
              </span>
            </div>
          </div>
        </Container>
      </>
    );
  }
};
export { InsightDetails };
